import React from "react";
import "./Footer.css"
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";
import { useTranslation } from "react-i18next";


const Footer = () => {
    const { t, i18n } = useTranslation();
    const changeLanguage = lng => {
        i18n.changeLanguage(lng);
    };

    return (
        <div>
            <Navbar bg="dark" variant="dark" sticky="bottom" expand="lg">
                <Navbar.Brand href="/" className={"p-0 text-center"}>
                    <img
                        src={require("../Image/Logo_ec_final.png")}
                        height="40em"
                        style={{objectFit: "cover"}}
                        alt="React Bootstrap logo"
                    />
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="basic-navbar-nav" />

                <Navbar.Collapse className="align-items-center justify-content-center">
                    <Nav>
                        {/*<Image className= "Logo"src={require("../Image/Logo_ec_final.png")}/>*/}
                        <Nav.Link href="/"> <Nav.Item>{t("home")}</Nav.Item></Nav.Link>
                        <Nav.Link href="/aboutus"> <Nav.Item>{t("background")}</Nav.Item></Nav.Link>
                        <Nav.Link href="/experience"><Nav.Item>{t("experience")}</Nav.Item></Nav.Link>
                        <Nav.Link href="/news"> <Nav.Item>{t("news")}</Nav.Item></Nav.Link>
                        <Nav.Link href="/contact"> <Nav.Item>{t("contact")}</Nav.Item></Nav.Link>
                        <Nav.Link href="/legal"> <Nav.Item>{t("legal")}</Nav.Item></Nav.Link>
                    </Nav>
                </Navbar.Collapse>

                <ButtonGroup className="text-center" toggle>
                    <ToggleButton
                        key="fr"
                        type="radio"
                        variant="outline-secondary"
                        name="radio"
                        value="fr"
                        checked={i18n.language === "fr"}
                        onChange={(e) => changeLanguage("fr")}
                    >
                        FR
                    </ToggleButton>
                    <ToggleButton
                        key="en"
                        type="radio"
                        variant="outline-secondary"
                        name="radio"
                        value="en"
                        checked={i18n.language === "en"}
                        onChange={(e) => changeLanguage("en")}
                    >
                        EN
                    </ToggleButton>
                </ButtonGroup>
            </Navbar>
        </div>
    );
};

export default Footer;
